import { CssBaseline, ThemeProvider } from '@mui/material';
import { QueryClientProvider } from 'react-query';
import { BrowserRouter } from 'react-router-dom';
import AppLayout from './layout/AppLayout';
import { theme } from './theme';
import { Auth0ProviderWithHistory } from './auth';
import { UserContextProvider } from './auth/AuthContext';
import { queryClient } from './react-query/queryClient';
import { ReactQueryDevtools } from 'react-query/devtools';
import { ToastContainer } from 'react-toastify';
import RouteList from './router/RouteList';

const App = () => (
  <BrowserRouter>
    <ThemeProvider theme={theme}>
      <Auth0ProviderWithHistory>
        <UserContextProvider>
          <QueryClientProvider client={queryClient}>
            <CssBaseline />
            <AppLayout>
              <RouteList />
            </AppLayout>
            <ToastContainer limit={2} />
            <ReactQueryDevtools initialIsOpen={false} />
          </QueryClientProvider>
        </UserContextProvider>
      </Auth0ProviderWithHistory>
    </ThemeProvider>
  </BrowserRouter>
);

export default App;
